const locks = new WeakMap<HTMLElement, { owners: number; overflow: string }>();

/** A closing menu and the search dialog can overlap during the handover. */
export function lockHeaderScroll(body: HTMLElement): () => void {
  let lock = locks.get(body);
  if (!lock) {
    lock = { owners: 0, overflow: body.style.overflow };
    locks.set(body, lock);
    body.style.overflow = "hidden";
  }
  lock.owners++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--lock.owners === 0) {
      body.style.overflow = lock.overflow;
      locks.delete(body);
    }
  };
}
